export default {
  carousel_index: 0
}
